<template>
  <div class="container">
    <app-header title="售后/退款"/>
    <div class="message" v-for="(item,index) in dataList" :key="index">
      <div class="headrefund">
        <img src="@/assets/priceImg.png" width="16" height="16">
        <div class="hint">退款</div>
      </div>

      <div>
        <div class="content" v-for="(product,index) in item.shopOrder.orderItemList" :key="index" @click="orderDetails(product.shopProduct.id)">
          <img :src="product.shopProduct.image" width="98px" height="110px"/>
          <div class="messages">
            <div class="title">{{product.shopProduct.name}}</div>
            <div class="price">￥{{product.totalPrice}}</div>
            <div class="mehint">已选: {{product.description}}</div>
          </div>
        </div>
        <div class="allprice" style="text-align: right" v-if="item.returnResult===0 || item.returnResult===0">申请退款金额:￥{{item.backMoney}}</div>
        <div class="allprice" style="text-align: right" v-if="item.returnResult===1">已退款:￥{{item.returnAmount}}</div>
      </div>

      <div class="allstatus" style="display: flex;justify-content: space-between;">
        <div class="status" v-if="item.returnResult == 0" style="position: relative;left: 8px;">审核中</div>
        <div class="status" v-if="item.returnResult == 1" style="position: relative;left: 8px;">退款成功</div>
        <div class="status" v-if="item.returnResult == 2" style="position: relative;left: 8px;">退款失败</div>
        <!--<div class="reprice" style="position: relative;right: 8px;">退款金额￥{{item.shopOrder.orderItemList[0].price}}</div>-->
      </div>
      <div style="display: flex">
         <div class="pay" style="color: #666666;border: 1px solid #666666;margin-left: 45%" @click="delShopProblem(item.id)">删除记录</div>
        <div class="pay" @click="refundDetatils(item.id)">查看详情</div>
      </div>
    </div>
    <empty v-if="dataList.length == 0" />
  </div>
</template>

<script>
import { queryShopProblemList,delShopProblem } from '@/api/order/index.js'
export default {
  name: 'AfterRefund',
  data() {
    return {
      dataList : []
    }
  },
  created() {
    this._queryShopProblemList()
  },
  methods: {
    delShopProblem(id){
      this.$dialog.confirm({
        title: '是否确认删除？'
      }).then(() => {
        delShopProblem({id: id}).then((res) => {
          if (res.success) {
            this.$toast.success("删除成功");
            this._queryShopProblemList()
          }
        })
      }).catch(() => {

      });
    },
    _queryShopProblemList() {
      var user = localStorage.getItem('userInfo')
      user = JSON.parse(user)
      const params = {
        uid: user.id,
        isDel: 0,
        type: this.activeTag,
        // sysCounpon: {
          //couponTwotype: this.twoActiveTag
        //}
      }
      queryShopProblemList(params).then((res) => {
        if (res.success) {
          console.log(res)
          this.dataList = res.data
        }
      })
    },
    orderDetails(id) {
      this.$router.push({
        path: '/product/detail',
        query: {
          id: id,
        }
      })
    },
    refundDetatils(id) {
      this.$router.push({
        path: '/mine/refund/refundDetatils',
        query:{
          pid : id
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .container{
    .message{
      border-bottom:2px solid #f3f3f3;
      padding: 10px;
      .headrefund{
        display: flex;
        margin-bottom: 12px;
        margin-left: 80%;
        .hint{
          margin-left: 6px;
          font-size:14px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:20px;
          color:rgba(51,51,51,1);
          opacity:1;
        }
      }
      .content{
        display: flex;
        flex-direction: row;
        margin-bottom: 10px;
        .messages{
          margin-left: 17px;
          .title{
            height:36px;
            font-size:13px;
            font-family:PingFang SC;
            font-weight:400;
            line-height:18px;
            color:rgba(51,51,51,1);
            opacity:1;
            overflow: hidden;
            word-wrap: break-word;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp:2;
            flex: 1;
          }
          .price{
            height:47px;
            font-size:13px;
            font-family:PingFang SC;
            font-weight:400;
            line-height:18px;
            color:rgba(51,51,51,1);
            opacity:1;
          }
          .mehint{
            height:18px;
            font-size:12px;
            font-weight:400;
            line-height:17px;
            color:rgba(136,137,136,1);
            background:rgba(243,243,243,1);
            border-radius:1px;
            padding: 1px 3px;
          }
          .refund-money{
            margin-top: 13px;
            height: 17px;
            font-size: 12px;
            font-weight: 400;
            line-height: 17px;
            color: #333333;
          }
        }
      }
      .allprice{
        font-size:12px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:17px;
        color:rgba(51,51,51,1);
        opacity:1;
        margin-top: 10px;
        margin-left: 30%;
      }
      .allstatus{
        display: flex;
        height:37px;
        background:rgba(243,243,243,1);
        opacity:1;
        margin-left: 2%;
        margin-top: 8px;
        .status{
          font-size:14px;
          font-family:PingFang SC;
          font-weight:bold;
          line-height:37px;
          color:rgba(51,51,51,1);
          opacity:1;
        }
        .reprice{
          font-size:14px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:37px;
          color:rgba(51,51,51,1);
          margin-left: 45px;
          opacity:1;
        }
      }
      .pay{
        margin-top: 30px;
        margin-left: auto;
        margin-right: 12px;
        width:84px;
        height:28px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(254,0,59,1);
        opacity:1;
        text-align: center;
        border-radius:14px;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:28px;
        color:rgba(254,0,59,1);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/refund/afterRefund.vue